import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import { sideBarItems } from './sidebar-items';
import { Link } from 'react-router-dom';
import { useToggle } from '@lib/common';
import { FcComboChart } from '@icon/react-icons';
import { ProfileButton } from './profile-button';
import AppConfig from '@components/app-config';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';
import { Footer } from './footer';
import { Paper } from '@material-ui/core';

const drawerWidth = 240;

export function Layout({ children = null, sidebar: SideBarItems }) {
  const classes = useStyles();
  const [drawerOpen, toggleDrawer, openDrawer, closeDrawer] = useToggle(false);

  const { appBarTitle: appTitle, noPagePadding = false } = AppConfig.use();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            className={clsx(classes.menuButton, drawerOpen && classes.menuButtonHidden)}>
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            {appTitle}
          </Typography>
          <Typography
            align="right"
            component={Link}
            to="/landing-page"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}>
            Vitrina DELI
          </Typography>
          <ProfileButton />
        </Toolbar>
      </AppBar>
      <Drawer
        // variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
        }}
        onClose={closeDrawer}
        open={drawerOpen}>
        <div className={classes.toolbarIcon}>
          <Typography component="h1" variant="h6" color="inherit" noWrap>
            <IconButton color="inherit" component={Link} to="/">
              <FcComboChart />
            </IconButton>
            Vitrina DELI
          </Typography>
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <SideBarItems closeDrawer={closeDrawer} openDrawer={openDrawer} />
        </List>
      </Drawer>
      <FancyMain id="deli-main-content" className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container
          maxWidth={false}
          className={classes.container}
          style={{ padding: noPagePadding ? 0 : null }}>
          {children}
        </Container>
        <Paper component="footer" style={{ marginTop: noPagePadding ? 10 : null }} elevation={6}>
          <Footer />
        </Paper>
      </FancyMain>
    </div>
  );
}

const FancyMain = styled.main`
  ${thumbStack}
`;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 5,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    textDecoration: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    // backgroundColor:
    //   theme.palette.mode === 'light'
    //     ? theme.palette.grey[100]
    //     : theme.palette.grey[900],
    position: 'relative',
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    position: 'relative',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));
